<template>
  <div class="main-content contact">
    <section class="inner-header about-us">
      <div class="container pt-60 pb-70">
        <!-- Section Content -->
        <div class="section-content">
          <div class="row">
            <div class="col-md-12">
              <h2 class="title">Kesan Spesial</h2>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="map-location">
      <div class="container container-fluid pb-0">
        <!-- Google Map HTML Codes -->
        <div class="map-content">
          <iframe
            frameborder="0"
            scrolling="no"
            marginheight="0"
            marginwidth="0"
            src="https://maps.google.com/maps?q=Rumah%20Sakit%20UII&amp;t=m&amp;z=14&amp;output=embed&amp;iwloc=near"
            aria-label="Rumah Sakit UII"
            style="width: 100%; height: 350px"
          ></iframe>
        </div>
      </div>
    </section>
    <section class="contactus-containter">
      <div class="container pt-0">
        <div class="row pt-30">
          <div class="col-md-12 col-lg-4">
            <div class="row">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-12">
                <div class="icon-box left media bg-deep p-30 mb-20">
                  <a class="media-left pull-left" href="javascript:;">
                    <i class="fa fa-map-marker text-theme-colored"></i>
                  </a>
                  <div class="media-body">
                    <h5 class="mt-0">Alamat</h5>
                    <p>JL. SRANDAKAN KM. 5,5, PANDAK, BANTUL Daerah Istimewa Yogyakarta 55761</p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-12">
                <div class="icon-box left media bg-deep p-30 mb-20">
                  <a class="media-left pull-left" href="javascript:;">
                    <i class="fa fa-phone text-theme-colored"></i>
                  </a>
                  <div class="media-body">
                    <h5 class="mt-0">Nomor Telepon</h5>
                    <p>(0274) 2812-999</p>
                  </div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-12">
                <div class="icon-box left media bg-deep p-30 mb-20">
                  <a class="media-left pull-left" href="javascript:;">
                    <i class="fa fa-envelope text-theme-colored"></i>
                  </a>
                  <div class="media-body">
                    <h5 class="mt-0">Alamat Email</h5>
                    <p>publicrelations@rsuii.co.id</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-12 col-lg-8">
            <h3 class="line-bottom mt-0 mb-30">Interested in discussing?</h3>
            <!-- Contact Form -->
            <form id="contact_form" name="contact_form" onsubmit="return false">
              <div class="row">
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>
                      Name
                      <small>*</small>
                    </label>
                    <input
                      name="form_name"
                      v-model="form_name"
                      class="form-control"
                      type="text"
                      placeholder="Enter Name"
                      required
                    />
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>
                      Email
                      <small>*</small>
                    </label>
                    <input
                      name="form_email"
                      v-model="form_email"
                      class="form-control required email"
                      type="email"
                      placeholder="Enter Email"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>
                      Subject
                      <small>*</small>
                    </label>
                    <input
                      name="form_subject"
                      v-model="form_subject"
                      class="form-control required"
                      type="text"
                      placeholder="Enter Subject"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>
                      Phone
                      <small>*</small>
                    </label>
                    <input
                      name="form_phone"
                      v-model="form_phone"
                      class="form-control"
                      type="number"
                      placeholder="Enter Phone"
                    />
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label>
                  Message
                  <small>*</small>
                </label>
                <textarea
                  name="form_message"
                  v-model="form_message"
                  class="form-control required"
                  rows="5"
                  placeholder="Enter Message"
                ></textarea>
              </div>

              <div class="form-group">
                <input name="form_botcheck" class="form-control" type="hidden" value />
                <button
                  type="submit"
                  :disabled="disabled"
                  @click="postEmail()"
                  class="btn btn-circled btn-theme-colored btn-flat mr-5"
                  data-loading-text="Please wait..."
                >
                  <i v-if="show_loading" class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                  <span v-if="!show_loading">Send your message</span>
                </button>
                <button
                  type="reset"
                  @click="eventReset()"
                  class="btn btn-dark btn-circled btn-default btn-flat btn-theme-colored"
                >Reset</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from "../services/api";

export default {
  data() {
    return {
      form_name: "",
      form_email: "",
      form_phone: "",
      form_subject: "",
      form_message: "",
      disabled: false,
      show_loading: false,
    };
  },
  methods: {
    postEmail() {
      this.show_loading = true;
      this.disabled = true;

      let payload = {
        name: this.form_name,
        email: this.form_email,
        phone: this.form_phone,
        subject: this.form_subject,
        content: this.form_message,
      };

      api
        .post(api.route.post.contact, payload)
        .then((data) => {
          let status = data.status;
          let message = data.message;
          if (status == 1) {
            alert(message);
            this.eventReset();
          } else {
            let errors = data.errors;
            let errors_message = "";
            for (let error_index in errors) {
              let error_item = errors[error_index];
              errors_message += error_item[0] + "\n";
            }
            alert(errors_message);
          }

          this.show_loading = false;
          this.disabled = false;
        })
        .catch((err) => {
          console.log(err);
          alert(err);
          this.show_loading = false;
          this.disabled = false;
        });
    },
    eventReset() {
      this.form_name = "";
      this.form_email = "";
      this.form_phone = "";
      this.form_subject = "";
      this.form_message = "";
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/pages/Contact.vue